import { Button, Form, Loader, Stack } from 'rsuite';
import { terminalIcon } from '../assets';
import { t } from 'i18next';
import { useState } from 'react';

interface IProps {
  onConnect: any;
  status: string;
}
export const WebsshLogin = ({ onConnect, status }: IProps) => {
  const [nameErrorVisibale, setNameErrorVisible] = useState<boolean>(false);
  const [passwordErrorVisibale, setPasswordErrorVisible] =
    useState<boolean>(false);
  const [formValue, setFormValue] = useState<Record<string, any>>({
    name: '',
    password: ''
  });
  const onSubmit = () => {
    if (status === 'connecting') {
      return;
    }
    setNameErrorVisible(!formValue.name);
    setPasswordErrorVisible(!formValue.password);
    if (onConnect && formValue.name && formValue.password) {
      onConnect(formValue);
    }
  };
  const checkEnterSubmit = (e: any) => {
    if (e?.key === 'Enter' && e?.shiftKey == false) {
      onSubmit();
    }
  };
  return (
    <Form
      layout="horizontal"
      formValue={formValue}
      onChange={(formValue) => setFormValue(formValue)}
    >
      <Stack justifyContent="center" style={{ marginBottom: '18px' }}>
        <img src={terminalIcon} width="38px"></img>
        <h3 style={{ color: '#EE5A24' }}>SSH</h3> <h3>LOGIN</h3>
      </Stack>
      <Form.Group controlId="name">
        <Form.Control
          name="name"
          placeholder={t('common.webssh.username')}
          errorMessage={
            nameErrorVisibale ? t('common.webssh.errorMessage') : null
          }
          errorPlacement={'rightStart'}
          onKeyDown={checkEnterSubmit}
        />
      </Form.Group>
      <Form.Group controlId="password">
        <Form.Control
          name="password"
          placeholder={t('common.webssh.password')}
          errorMessage={
            passwordErrorVisibale ? t('common.webssh.errorMessage') : null
          }
          errorPlacement={'rightStart'}
          type="password"
          autoComplete="off"
          onKeyDown={checkEnterSubmit}
        />
      </Form.Group>
      <Form.Group style={{ width: '100%', marginBottom: 0 }}>
        <Button
          appearance="primary"
          onClick={onSubmit}
          // disabled={status === 'connecting'}
        >
          {status === 'connecting' ? (
            <Loader content={t('common.webssh.connecting')} />
          ) : (
            t('common.webssh.connect')
          )}
        </Button>
      </Form.Group>
    </Form>
  );
};
